// Malá živá váha v hlavičce (rozhodnutí zadavatele 12. 10. 2026; prototyp „ECOser App.dc.html“ ř. ~274): hmotnost
// ve váze a stav (ustálená / mění se / neodpovídá) s proklikem do Vážení. Vidí ji jen role, která smí vážit
// (`vazeni.vazit`), a jen s účtem, který má sekci Vážení — jinde by odkaz vedl na zákaz. Data dává stejný hook jako
// panel ve Vážení a Můj den (`useZivyStavVahy`): stream se otevře jen dokud je váha v hlavičce vykreslená a zavře
// se s odmontováním. Na obrazovce Vážení se váha nekreslí (panel je tam celý a druhý stream by byl zbytečný), na
// telefonu také ne (hlavička je plná; Vážení je ve spodní liště/menu). Offline nebo neznámý stav hlavičku nerozbije:
// ukáže se „– – –“ s popisem „Váha neodpovídá“. Stream váhy je s Můj den a Vážením sdílený (`zivy-stav.ts`,
// jeden odběr na váhu). Když se kód živé váhy nestáhne (tablet bez signálu a bez mezipaměti), váha v hlavičce
// jen chybí — tichá hranice `NacitaniCasti` nedovolí, aby selhání bloku složilo celou aplikaci.
import type { Ja } from '@ecoser/shared';
import { useLocation } from 'react-router';
import { lina, NacitaniCasti } from '../komponenty/NacitaniCasti';
import { maAkci } from '../komponenty/prava';
import { DOTAZ_TELEFON, useMediaDotaz } from './telefon';
import './hlavicka-navigace.css';

const SEKCE_VAZENI = 'vazeni';
/** Akce `vazeni.vazit` (stejný klíč jako `AKCE_VAZIT` v api/vazeni.ts — tady zvlášť, ať se API Vážení netáhne do hlavního balíku). */
const AKCE_VAZIT = 'vazeni.vazit';

// Stream a API Vážení se stahují až u toho, kdo váhu v hlavičce vidí (rozpočet hlavního balíku, docs/09 §12).
const ZivaVaha = lina(() => import('./ZivaVaha').then((m) => m.ZivaVaha));

export function VahaVHlavicce({ ja }: { ja: Ja }) {
  const { pathname } = useLocation();
  const telefon = useMediaDotaz(DOTAZ_TELEFON);
  const smi = maAkci(ja.akce, AKCE_VAZIT) && (ja.sekce ?? []).includes(SEKCE_VAZENI);
  if (!smi || telefon || pathname === '/vazeni' || pathname.startsWith('/vazeni/')) return null;
  return (
    <NacitaniCasti tiche>
      <ZivaVaha />
    </NacitaniCasti>
  );
}
